module.exports = "./img/910d42170bad181b2f68988000418dc4.jpg";